import Modal from '@mui/material/Modal/Modal';
import { FC } from 'react';
import Box from '@mui/material/Box/Box';
import { zIndex } from 'styles';

type ContactModalProps = { onClose: () => void; isOpen: boolean };

export const SubscribeModal: FC<ContactModalProps> = ({ isOpen, onClose }) => {
  return (
    <Modal
      sx={{
        zIndex: zIndex.modal,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
      open={isOpen}
      onClose={onClose}
      aria-labelledby="contact-modal-title"
      aria-describedby="contact-modal-description"
    >
      <Box
        sx={{
          backgroundColor: 'white',
          maxWidth: '658px',
          height: '350px',
          overflow: 'auto',
          width: '100%',
        }}
      >
        <div
          className="hs-form-frame"
          data-region="na1"
          data-form-id="e98d838d-1f38-40c3-911c-e48e04aefe67"
          data-portal-id="7805184"
        ></div>
      </Box>
    </Modal>
  );
};
